import { useApiQuery } from "@frontend/hooks/use-api"
import { PathologyViewerPage } from "@frontend/pages/case-workspace/pathology/page"
import { AnnotationViewerPage } from "@frontend/pages/case-workspace/radiology/page"
import { useParams } from "react-router"

interface ProjectWorkflowShape {
  id: string
  workflow?: "radiology" | "pathology"
}

export function CaseWorkspacePage() {
  const { projectId, submissionId } = useParams<{
    projectId: string
    submissionId: string
  }>()
  const reviewSubmissionId = submissionId ?? null

  const { data: project, isLoading } = useApiQuery<ProjectWorkflowShape>(
    ["projects", projectId!, "workflow"],
    `/projects/${projectId}`,
    { enabled: Boolean(projectId) }
  )

  if (isLoading) {
    return (
      <div className="h-screen bg-background p-6">
        <p className="text-sm text-muted-foreground">Loading workspace...</p>
      </div>
    )
  }

  if (project?.workflow === "pathology") {
    return <PathologyViewerPage reviewSubmissionId={reviewSubmissionId} />
  }

  return <AnnotationViewerPage reviewSubmissionId={reviewSubmissionId} />
}
